/**
 * Creates a HTMLElement using the given data.
 * @param {String} type Tag name.
 * @param {Object} attributes Element attributes.
 * @param  {...(HTMLElement || String)} children Element content, either a list of elements and strings.
 * @return {HTMLElement} Resulting element.
 */
export default function (tag, attributes, ...children) {
  const element = document.createElement(tag);
  Object.keys(attributes).forEach(key => {
    const value = attributes[key];
    switch (typeof value) {
      default:
        console.warn('hyperscript: unsupported value type for attribute with key "' + key + '" and type "' + typeof value + '".');
        break;
      case 'function':
        element.addEventListener(key, value);
        break;
      case 'number':
      case 'string':
        element.setAttribute(key, value);
        break;
      case 'undefined':
        // Fail silently.
        break;
    }
  });
  if (children) {
    // Flatten children.
    children = children.flat();

    // Add children.
    children.forEach(child => {
      if (typeof child === 'string') {
        child = document.createTextNode(child);
      }
      element.append(child);
    });
  }
  return element;
}
;